import { UPDATE_SUPPLIER, RESET_SUPPLIER } from "./actionTypes";
import * as Yup from "yup";
const supplierBase = {
  id: "",
  name: "",
  phone: "",
  prefix_id: "",
  email: "",
  payment_method_id: "",
  company_id: "",
  company_supplier_id: "",
  supplier_type_id: "",
  newCompany: "",
};

const initialState = {
  supplier: { ...supplierBase },
  supplierValidations: {
    supplier_type_id: Yup.string().required(),
    payment_method_id: Yup.string().required(),
    name: Yup.string().required("Name is required"),
    phone: Yup.string()
      .matches(/^\d+$/, "Phone must contain only numbers")
      .max(10, "Phone can have a maximum of 10 digits")
      .required("phone is required"),

    email: Yup.string()
      .email("Email is not valid")
      .required("email is required"),

    company_supplier_id: Yup.string().test(
      "company_supplier_id-required",
      "Please select a company",
      function (value) {
        const { newCompany } = this.parent;
        // Si NO es una nueva empresa, company_id es obligatorio.
        if (!newCompany) {
          return Boolean(value);
        }
        // Si es una nueva empresa, no se valida este campo.
        return true;
      }
    ),
    name_company: Yup.string().test(
      "name_company-required",
      "Company name is required",
      function (value) {
        const { newCompany } = this.parent;
        // Si es nueva empresa, el nombre es obligatorio.
        if (newCompany) {
          return Boolean(value);
        }
        return true;
      }
    ),
    address: Yup.string().test(
      "address-required",
      "Company address is required",
      function (value) {
        const { newCompany } = this.parent;
        // Si es nueva empresa, la dirección es obligatoria.
        if (newCompany) {
          return Boolean(value);
        }
        return true;
      }
    ),
    prefix_id: Yup.string() // para permitir un valor nulo inicialmente
      .required("prefix is required"),
  },
};

const supplier = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SUPPLIER:
      // Actualizar el estado
      return {
        ...state,
        supplier: action.payload,
      };
    case RESET_SUPPLIER:
      // Actualizar el estado
      return {
        ...state,
        supplier: { ...supplierBase },
      };
    default:
      return state;
  }
};

export default supplier;
